<div
    class="organization-details-page-container"
    *ngIf="organizationDetailsForm"
>
    <form
        [formGroup]="organizationDetailsForm"
        class="organization-details-form"
    >
        <div class="form-boxes-wrapper">
            <!-- Left Box: Personal Data -->
            <div class="border-container">
                <!-- Name fields (side-by-side layout) -->
                <div class="columns">
                    <div class="column">
                        <div *ngFor="let field of fields" class="form-group">
                            <label [for]="field.id">{{
                                field.labelKey | translate
                            }}</label>
                            <div class="input-wrapper position-relative">
                                <input
                                    type="text"
                                    [id]="field.id"
                                    class="organization-details-form-control"
                                    [formControlName]="field.id"
                                    [readonly]="true"
                                    (focusout)="
                                        focusFieldOnError($event, field.id)
                                    "
                                />
                                <div
                                    class="error-div"
                                    *ngIf="
                                        !organizationDetailsForm?.get(field.id)
                                            ?.pristine &&
                                        organizationDetailsForm?.get(field.id)
                                            ?.invalid
                                    "
                                >
                                    <app-display-errors
                                        [control]="
                                            organizationDetailsForm.get(
                                                field.id
                                            )
                                        "
                                        [translationKey]="field.errorKey"
                                    ></app-display-errors>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column align-items-end">
                        <div class="button-wrapper-tryb-button">
                            <button
                                *ngIf="isExperimentalUser"
                                id="user-organization-details-delete-organization-button"
                                type="button"
                                class="button-tryb-button delete-tryb-button"
                                (click)="onDeleteOrganization()"
                            >
                                {{
                                    'organization.organizationArea.organizationDetails.deleteOrganization'
                                        | translate
                                }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="save-button-container">
                <div class="button-wrapper-tryb-button">
                    <button
                        *ngIf="isExperimentalUser"
                        id="user-organization-details-save-changes-button"
                        type="button"
                        class="button-tryb-button standard-tryb-button"
                        (click)="saveChanges()"
                        [disabled]="
                            !hasUnsavedChanges() ||
                            organizationDetailsForm.invalid ||
                            updating
                        "
                    >
                        {{
                            'organization.organizationArea.organizationDetails.saveChanges'
                                | translate
                        }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
